import React from 'react';
import { Box, Container, Heading, Text, Button, VStack, Image } from '@chakra-ui/react';
import { FaPhone } from 'react-icons/fa';
import GetIntoTouch from '../../assets/getinTouch.webp';
import { useNavigate } from 'react-router-dom';


function GetInTouch() {
    const navigate = useNavigate();
  
  return (
    <Box
      id="take-action"
      position="relative"
      bgImage={`url(${GetIntoTouch})`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      py={{ base: 20, md: 28 }}
      color="white"
      textAlign="center"
    >
      {/* Overlay */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bg="blackAlpha.800"
        zIndex="0"
      />

      {/* Content */}
      <Container position="relative" zIndex="1"  data-aos="fade-up">
        <VStack spacing={6}>
          <Text
            fontSize="sm"
            textTransform="uppercase"
            letterSpacing="widest"
            color="customDarkBlue.300"
          >
            contact us
          </Text>

          <Heading
            fontSize={{ base: '2xl', md: '4xl' }}
            maxW="600px"
            // border={"1px solid red"}
          >
            {/* Get in touch with us */}
            Ready to Transform Your Business?
          </Heading>

          <Text fontSize="md" maxW="900px" opacity={0.8}>
          Partner with Dremotech Solutions to bring your digital vision to life. Let’s create something extraordinary together!
          </Text>

          <Button
            bg="customDarkBlue.200"
            transition="all 0.3s ease"
            border="2px solid transparent"
            leftIcon={<FaPhone />}
            _hover={{
                bg: 'transparent',
                color: 'blue.300',
                border: '2px solid',
                borderColor: 'blue.400',
            }}
            size="lg"
            as="a"
            onClick={() => navigate('/contact')}
          >
            Contact Us Now
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}

export default GetInTouch;
